import React, { Component } from 'react';
import Slider from "react-slick";

class Review extends Component {
    constructor(props){
        super(props);
        this.state = {
            testimonial: [
                {
                    id: 1,
                    img: './assets/images/clients/test-1.jpg',
                    alt: 'images',
                    quoteText: 'Good reporting',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas sed  risus pellentesque, pharetra nibh nec, pulvinar libero. Proin et laoreet  lorem, vel auctor massa.',
                    name: 'John Doe',
                    desigantion: 'Manager',
                },
                {
                    id:2,
                    img: './assets/images/clients/test-2.jpg',
                    alt: 'images',
                    quoteText: 'Excellent!',
                    text: 'Maecenas sed  risus pellentesque, pharetra nibh nec, pulvinar libero. Proin et laoreet  lorem, vel auctor massa..',
                    name: 'Joan Muir',
                    desigantion: 'Nursery manager',
                },
                {
                    id: 3,
                    img: './assets/images/clients/test-3.jpg',
                    alt: 'images',
                    quoteText: 'Very useful',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas sed  risus pellentesque, pharetra nibh nec, pulvinar libero. Proin et laoreet  lorem, vel auctor massa.',
                    name: 'Sophie Happy',
                    desigantion: 'Teacher',
                },
                {
                    id:4,
                    img: './assets/images/clients/test-2.jpg',
                    alt: 'images',
                    quoteText: 'Very Effective!',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                    name: 'John Dodds',
                    desigantion: 'Teacher',
                },
            ]
        }
    }

    render() {
        const settings = {
            dots: true,
            infinite: true,
            centerMode: true,
            arrows: false,
            autoplay: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '40px',
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
          };
        return (
        <section className="testimonial section-padding bg-grey " id="testimonial">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-6 col-lg-8">
                        <div className="section-heading center-heading text-center mb-60">
                            <h3 className="heading-title">Reviews from happy providers</h3>
                            <p>Reviews from some of our nurseries and schools using School Ready Passport.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
            <div className="row justify-content-center">
                    <div className="col-lg-12">
                        <div className="testimonials-slides">
                            <Slider {...settings} >
                            {
                                this.state.testimonial.map((data) => (
                                    <div className="review-item" key={data.id}>
                                        <div className="client-info">
                                            <div className="rating">
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                                <i className="fa fa-star"></i>
                                            </div>
                                            <h4>{data.quoteText}</h4>
                                            <p>{data.text}</p>
                                        </div>

                                        <div className="client-desc d-flex align-items-center">
                                            <div className="client-text">
                                                <h5>{data.name}</h5>
                                                <span className="designation">{data.desigantion}</span>
                                            </div>
                                        </div>
                                    </div> 
                                ))
                            }
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    </section>
        );
    }
}

export default Review;
